module.exports = __webpack_public_path__ + "img/CelticMagic_DG.660061dd.png";